module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"walk":"Walk"},"ja":{"walk":"巡回"}}')
  delete Component.options._Ctor
}
